import { api, cacheFirstConfig } from '@/core/helpers/axiosHelper';

export default {
   async get() {
      return await api
         .get('/language', {
            ...cacheFirstConfig,
            params: {
               'filter[is_communication_language]': 1,
            },
         })
         .then((response) => response?.data);
   },
};
